import { 
    HTMLAttributes, 
    useCallback, 
    useRef, 
    useEffect 
} from "react";
import { initAdv, injectAdv } from "@sky-uk/sky-adv";
import {
  IScorersRankingPlayerPageProps,
  ScorersRankingPlayerPage,   
  observedTypes,
} from "@sky-it-livedata/livedata-sports-design-system"; 
import { getAdvBoxAttributes, AdvBoxType, setManualScrollRestoration, analyticsTrack } from "@sky-it-livedata/common-web-app-utils";
import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { ScorersRankingPlayerPageQuery } from "./types";
import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<ScorersRankingPlayerPageQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<ScorersRankingPlayerPageQuery>): IScorersRankingPlayerPageProps => {
  return transformer(props);
};
const scorersRankingPlayerPage = ({
  props,
  ...rest
}: WidgetContext<IScorersRankingPlayerPageProps>) => {
  log({ props, ...rest });

  const scorersInstance = useRef<any>(null);

  const scorersRef = useCallback((node: any) => {
    if (node) {
      scorersInstance.current = node;
      const advElements = [...node.fullPlayersRef, ...node.rowPlayersRef];
      if (advElements && advElements.length > 0) {
        advElements.forEach((advElement: HTMLElement) => {
          trackElementInViewport({ element: advElement });
        });
      }
    }
  }, []);

  const trackElementInViewport = (params: { element: HTMLElement }) => {
    const { element } = params;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const item = entry.target as HTMLElement;
          const adv = item.querySelector(
            "[data-card-adv-content]"
          ) as HTMLElement | null;

          if (adv && !adv?.querySelector("ins")) {
            injectAdv(adv);
            initAdv(adv);
          }

          if (item.dataset?.observeType === observedTypes.PLAYER_FULL) {
            scorersInstance.current.handleSeasonCard({
              element: entry.target as HTMLElement,
              sizes: { size1x: 220, size2x: 440 },
            });
          }

          if (item.dataset?.observeType === observedTypes.PLAYER_ROW) {
            scorersInstance.current.handleSeasonCard({
              element: entry.target as HTMLElement,
              sizes: { size1x: 50, size2x: 100 },
            });
          }

          if (item.dataset?.analyticsCard!) {
            analyticsTrack("change_gallery", {
              hash: `#${item.dataset.analyticsCard}`,
            });
          }

          scorersInstance.current.removeObserveType(item);
        }
      });
    });
    observer.observe(element);
  };

  const advBoxesAttributes = getAdvBoxAttributes(
    `scorers-ranking-player-page-${props.competitionSlugName}` as AdvBoxType
  ) as HTMLAttributes<HTMLDivElement> & {
    "data-revivezoneid": string;
    "data-reviveid": string;
  };

  useEffect(() => {
    setManualScrollRestoration();
  }, []);

  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
            <ScorersRankingPlayerPage
                ref={scorersRef}
                {...props}
                advBoxAttributes={advBoxesAttributes}
            />
    </div>
  );
};

export default scorersRankingPlayerPage;
